// Compiled using marko@4.28.10 - DO NOT EDIT
"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry = require("marko/dist/runtime/components/registry"),
    marko_registerComponent = components_registry.r,
    marko_componentType = marko_registerComponent("/wetracker$1.0.0/src/components/effects_editor/effects/templates/overdrive.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    effect_header_tag = marko_loadTag(require("./components/effect-header")),
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("593f9d"),
    marko_node0 = marko_createElement("div", {
        "class": "control-group horizontal"
      }, "2", null, 2, 0, {
        i: marko_const_nextId()
      })
      .e("div", {
          "class": "control-group"
        }, null, null, 3)
        .e("div", {
            "class": "control"
          }, null, null, 3)
          .e("div", {
              "class": "label"
            }, null, null, 1)
            .t("Output Gain")
          .e("div", {
              id: "output-slider",
              "class": "slider"
            }, null, null, 0)
          .e("input", {
              type: "text",
              id: "output-value",
              value: "0.5"
            }, null, null, 0)
        .e("div", {
            "class": "control"
          }, null, null, 3)
          .e("div", {
              "class": "label"
            }, null, null, 1)
            .t("Drive")
          .e("div", {
              id: "drive-slider",
              "class": "slider"
            }, null, null, 0)
          .e("input", {
              type: "text",
              id: "drive-value",
              value: "0.7"
            }, null, null, 0)
        .e("div", {
            "class": "control"
          }, null, null, 3)
          .e("div", {
              "class": "label"
            }, null, null, 1)
            .t("Curve Amount")
          .e("div", {
              id: "curve-slider",
              "class": "slider"
            }, null, null, 0)
          .e("input", {
              type: "text",
              id: "curve-value",
              value: "1"
            }, null, null, 0)
      .e("div", {
          "class": "control-group"
        }, null, null, 1)
        .e("div", {
            "class": "control"
          }, null, null, 3)
          .e("div", {
              "class": "label"
            }, null, null, 1)
            .t("Algorithm")
          .e("div", {
              id: "alg-slider",
              "class": "slider"
            }, null, null, 0)
          .e("input", {
              type: "text",
              id: "alg-value",
              value: "0"
            }, null, null, 0);

function render(input, out, __component, component, state) {
  var data = input;

  out.be("div", {
      "class": "effect-control-panel",
      "data-chain-index": "" + data.location.index
    }, "0", component);

  effect_header_tag({
      name: "Overdrive"
    }, out, __component, "1");

  out.n(marko_node0, component);

  out.ee();
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
